<template>
    <Modal id="settings-modal">
        <template v-slot:header>
            <div class="modl-header">
                <ModalTabs :tabs="tabs"
                           :selected-tab="selectedTab"
                           @select-tab="selectTab"></ModalTabs>
            </div>
        </template>

        <template v-slot:body>
            <component :is="selectedTab.component"
                       ref="current-tab-component"
                       @cancel="cancel"
                       @resolve="resolve" />
        </template>
    </Modal>
</template>

<script>
import LoginSettingsTab from '@/vue/modals/LoginSettings/LoginSettingsTab';
import Modal from '@/vue/components/Modals/Modal';
import ModalTabs from '@/vue/components/Modals/ModalTabs';
import { ModalPropsMixin } from '@/vue/mixins/ModalPropsMixin';
import { TabbedModalMixin } from '@/vue/mixins/TabbedModalMixin';

// The LoginSettingsModal uses a tabbed layout even though it only has one tab,
// because this makes it look similar to the regular settings modal and provides
// more consistency.
export default {
    name: 'LoginSettingsModal',

    components: {
        Modal,
        ModalTabs,
        LoginSettingsTab,
    },

    mixins: [
        ModalPropsMixin,
        TabbedModalMixin,
    ],

    data() {
        return {
            tabs: [
                {
                    name: 'login',
                    icon: 'fa-key',
                    label: 'LOGIN_SETTINGS.LOGIN_TAB_NAME',
                    component: 'LoginSettingsTab',
                },
            ],
        };
    },
};
</script>
